import React, { useState } from 'react';
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { Card } from "react-bootstrap";

const ProcessedRequests = (props) => {
    const { data, totalCount, refetch } = props;
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const [displayRecords, setDisplayRecords] = useState("00");


    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true,
        flex: 1,
        minWidth: 200,
        minHeight: 200,
        suppressMovable: true,
    };

    // if we had column groups, we could provide default group items here
    const defaultColGroupDef = {
        minHeight: 200,
    };

    return (
        <Card className="docg-card">
            <Card.Header className="customCardHeader d-flex justify-content-between">
                <Card.Title className="customCardTitle">
                    Processed Requests
                    {typeof totalCount === "number"
                        ? ` (${data?.length ?? 0} of ${totalCount})`
                        : data?.length
                            ? ` (${data.length})`
                            : ""}
                </Card.Title>
                <button onClick={() => refetch()} className="docg-save-btn">
                    Refresh
                </button>
            </Card.Header>
            <Card.Body className="docg-card-body p-0">
                <div className="ag-theme-alpine" style={{ height: "100%", minHeight: "200px", width: "100%", }}>
                    <AgGridReact
                        rowData={data}
                        defaultColDef={defaultColDef}
                        rowHeight={75}
                        defaultColGroupDef={defaultColGroupDef}
                        enableRangeSelection={true}
                        pagination={true}
                        paginationPageSize={displayRecords}
                        onGridReady={onGridReady}
                        animateRows={true}
                        suppressAggFuncInHeader={true}
                        suppressColumnVirtualisation={true}
                    >
                        <AgGridColumn
                            headerName="Beneficiary"
                            field="beneficiaryName"
                        ></AgGridColumn>
                        <AgGridColumn
                            headerName="Clinic Name"
                            field="clinicName"
                        ></AgGridColumn>
                        <AgGridColumn
                            headerName="Request Date & Time"
                            field="createdAt"
                            valueFormatter={(params) => {
                                if (params.value)
                                    return new Date(params.value).toLocaleString("en-US", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        hours: "2-digit",
                                        minutes: "2-digit",
                                    });
                                return "-";
                            }}
                        ></AgGridColumn>
                        <AgGridColumn
                            headerName="Account No"
                            field="bankAccountNumber"
                        ></AgGridColumn>
                        <AgGridColumn
                            headerName="IFSC Code"
                            field="ifscCode"
                        ></AgGridColumn>
                        {/* <AgGridColumn
                            headerName="Account Type"
                            field="accountType"
                        ></AgGridColumn>
                        <AgGridColumn
                            headerName="Business Type"
                            field="businessType"
                        ></AgGridColumn> */}
                        <AgGridColumn
                            headerName="Status"
                            field="status"
                        ></AgGridColumn>
                    </AgGridReact>
                </div>
            </Card.Body>
        </Card>
    );
}

export default ProcessedRequests;